import { Box, styled, Typography } from "@mui/material";

export const Title = styled(Typography)(({ iscolor, theme, fontSize }) => ({
  color: iscolor ? iscolor : theme.palette.custom.white,
  fontSize: fontSize ? fontSize : theme.typography.chipColor.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
}));
export const StyledBoxChip = styled(Box)(({ background, theme, padding }) => ({
  backgroundColor: background ? background : theme.palette.custom.danger,
  borderRadius: theme.borderRadius.radius.large,
  padding: padding ? padding : "5px 10px",
}));
export const StyledBoxDisplay = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "3px",
}));
